import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import MenuFilterDate, { MenuFilterAmount, MenuFilterStatus } from './Components/MenuFilter';
import { Stack } from '@mui/system';
import Button from '@mui/material/Button';

const columns = [
  { field: 'date', headerName: 'Request Date', width: 100 },
  { field: 'amount', headerName: 'Topup Amount', width: 130 },
  { field: 'orig_name', headerName: 'Orig Bank Name', width: 130 },
  {
    field: 'inst_ref',
    headerName: 'Instrument Ref',
    width: 140,
  },
  {
    field: 'transfer_date',
    headerName: 'Transfer / Deposite date',
    width: 140,
  },
  {
    field: 'bef_bank_name',
    headerName: 'Benef Bank Name',
    width: 140,
  },

  {
    field: 'benf_acc_num',
    headerName: 'Benef A/c',
    width: 140,
  },
  {
    field: 'benef_branch_ifsc',
    headerName: 'Benef Branch Code/IFSC',
    width: 140,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 140,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 140,
  },
  {
    field: 'rejected_date',
    headerName: 'Rejected Date',
    width: 140,
  },
  {
    field: 'reason',
    headerName: 'Reason',
    width: 140,
  },
  
 
];

const rows = [
  { id:1,date: '10-12-2024', amount: '100', orig_name: 'kumar', inst_ref: '1234567890',transfer_date:'10-04-2024',bef_bank_name:'SBI',benf_acc_num:'547894789',benef_branch_ifsc:'SBI009',remarks:'asd',status:'pending',rejected_date:'',reason:'' },
  
];

export default function StatusTable() {
  return (
    <div style={{ height: 400, width: '100%' }}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Stack direction='row' gap={2} alignItems='center'>
          <MenuFilterDate/>
          <MenuFilterAmount/>
          <MenuFilterStatus/>
        </Stack>
        <Stack direction='row' gap={2} alignItems='center'>
          <Button variant='contained' size='small'>Search</Button>
          <Button variant='contained' size='small'>Cancel</Button>
        </Stack>
      </Stack>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
      />
    </div>
  );
}
